import { Component, DestroyRef, Input, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { CurrencyConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';
import { MoneyService } from '@frontend/sports/common/core/feature/money';

import { CashoutSettingsBetInfo, CashoutSettingsType, IAutoCashoutBetslipNumbers } from '../../../../my-bets-base/models/early-payout';
import { CashoutSettingsService } from '../../../services/cash-out-settings.service';
import { MyBetsEarlyPayoutAutocashoutValidationService } from './my-bets-earlypayout-autocashout-validation.service';

@Component({
    selector: 'ms-my-bets-earlypayout-remove-autocashout',
    templateUrl: 'my-bets-earlypayout-remove-autocashout.html',
    standalone: false,
})
export class MyBetsEarlyPayoutRemoveAutocashoutComponent implements OnInit {
    @Input() betNumbers: IAutoCashoutBetslipNumbers;
    @Input() type: CashoutSettingsType;
    @Input() betTypeInfo: string;
    readonly cashoutSettingsType = CashoutSettingsType;

    bodyText = '';
    private betInfo: CashoutSettingsBetInfo | null = null;
    prependCurrencySymbol: boolean;
    private readonly destroyRef = inject(DestroyRef);
    constructor(
        private validationService: MyBetsEarlyPayoutAutocashoutValidationService,
        public sitecore: Sitecore,
        private csService: CashoutSettingsService,
        private currencyConfig: CurrencyConfig,
        private moneyService: MoneyService,
    ) {}

    private autoCashoutValue(): string {
        if (!this.betInfo || !this.betInfo.earlyPayout!.autoCashOutValue || !Number(this.betInfo.earlyPayout!.autoCashOutValue)) {
            return '';
        }

        const value = this.betInfo.earlyPayout!.autoCashOutValueWithoutStake || this.betInfo.earlyPayout!.autoCashOutValue;

        return `${value.toFixed(2)}`;
    }

    private notificationValue(): string {
        if (
            !this.betInfo ||
            !this.betInfo.earlyPayout!.autoCashoutNotificationValue ||
            !Number(this.betInfo.earlyPayout!.autoCashoutNotificationValue)
        ) {
            return '';
        }

        const value = this.betInfo.earlyPayout!.autoCashoutNotificationValueWithoutStake || this.betInfo.earlyPayout!.autoCashoutNotificationValue;

        return `${value.toFixed(2)}`;
    }

    get value(): string {
        if (this.type === CashoutSettingsType.Auto) {
            return this.validationService.localizeValue(this.autoCashoutValue());
        }

        if (this.type === CashoutSettingsType.Notify) {
            return this.validationService.localizeValue(this.notificationValue());
        }

        return '';
    }

    get currency(): string {
        if (!this.betInfo || !this.betInfo.possibleWinnings) {
            return '';
        }

        return this.betInfo.possibleWinnings.currency;
    }

    get getCurrencyWithSymbol() {
        return this.moneyService.transform(this.value, true, 2, false, '', this.currency);
    }

    ngOnInit(): void {
        this.betInfo = this.csService.getBetInfo(this.betNumbers.betslipId);
        this.csService.settingsChanged.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((betid: string) => this.autocashoutValueChanged(betid));
        this.bodyText =
            this.type === CashoutSettingsType.Auto
                ? this.sitecore.earlyPayoutV2.RemoveAutocashoutBodyText
                : this.sitecore.earlyPayoutV2.RemoveAutocashoutNotificationBodyText;
        if (this.betInfo?.possibleWinnings) {
            this.prependCurrencySymbol = this.currencyConfig.currencySymbolDisplayList.includes(this.betInfo.possibleWinnings.currency);
        }
    }

    private autocashoutValueChanged(betId: string): void {
        if (this.betInfo && betId !== this.betNumbers.betslipId) {
            return;
        }
        this.betInfo = this.csService.getBetInfo(this.betNumbers.betslipId);
    }
}
